import { ThemeType, UseThemeResult } from "@/hooks/useTheme"
import { createContext, useContext } from "react"

// Create a context with the full UseThemeResult shape
export const ThemeContext = createContext<UseThemeResult | null>(null)

// Hook to consume the context
export function useThemeContext(): UseThemeResult {
  const ctx = useContext(ThemeContext)
  if (!ctx) {
    throw new Error(
      "useThemeContext must be used inside a ThemeContext.Provider"
    )
  }
  return ctx
}

// The provider will be implemented in the main ThemeProvider component
export type { UseThemeResult, ThemeType }
